import { Box, TextField, Typography } from "@mui/material";
import React from "react";
const editableFieldsConfig = {
  pin: ["title", "pin_url", "description", "pin_place", "priority"],
  tickets_ads: ["subject", "count_ticket_send"],
  banner: ["title", "description"],
  trust: ["title", "description"],
};

const EditableField = ({
  label,
  value,
  field,
  parent,
  formData,
  setFormData,
  editingSection,
}) => {
  const isEditable = editableFieldsConfig[parent]?.includes(field);
  const handleChange = (field, value, parent = null) => {
    if (parent) {
      setFormData((prev) => ({
        ...prev,
        [parent]: { ...prev[parent], [field]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };
  return (
    <Box sx={{ mb: 2.5 }}>
      <Typography
        variant="caption"
        color="textSecondary"
        sx={{ fontWeight: 500 }}
      >
        {label}
      </Typography>
      {isEditable && editingSection === parent ? (
        <TextField
          fullWidth
          variant="outlined"
          size="small"
          value={value}
          onChange={(e) => handleChange(field, e.target.value, parent)}
          sx={{
            mt: 0.5,
            "& .MuiOutlinedInput-root": {
              borderRadius: 2,
              bgcolor: "white",
            },
          }}
        />
      ) : (
        <Typography variant="body1" sx={{ mt: 0.5, fontWeight: 500 }}>
          {value || "N/A"}
        </Typography>
      )}
    </Box>
  );
};
export default EditableField;
